import { render } from "./post-details.vue?vue&type=template&id=b4d2c2d6"
import script from "./post-details.vue?vue&type=script&lang=js"
export * from "./post-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__